<section class="technology-area pt-70">
    <div class="container">
        <div class="section-title">
            <h2>¿Por Qué Elegir enCloud Frente a AWS, Azure o Google Cloud?</h2>
            <p class="text-justify">A diferencia de los gigantes globales, nuestros servicios están optimizado para
                empresas y negocios en
                México, ofreciendo:</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-coins"></i>
                    </div>

                    <h3>Precios en Moneda Local</h3>
                    <p>Sin cargos ocultos o especiales ni tarifas en moneda extranjera.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-location-dot"></i>
                    </div>

                    <h3>Infraestructura en México</h3>
                    <p>Para cumplir con normativas locales y leyes nacionales.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-headset"></i>
                    </div>

                    <h3>Soporte en Español</h3>
                    <p>Atención personalizada y tiempos de respuesta rápidos.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-gauge"></i>
                    </div>

                    <h3>Planes Flexibles y Personalizados</h3>
                    <p>Tenemos el plan indicado para ti y todos tus servicios.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-gear"></i>
                    </div>

                    <h3>Simplicidad en la Gestión</h3>
                    <p>Simplemente sencillo, no tenemos la complejidad de otros.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-house-signal"></i>
                    </div>

                    <h3>Baja Latencia</h3>
                    <p>Tiempos de respuesta rápidos para todos tus servicios.</p>
                </div>
            </div>
        </div>
    </div>
</section>